/**
 * WordPress dependencies.
 */
import { Icon } from '@wordpress/components';
import { floor } from 'lodash';

const showRatingStar = ( attributes ) => {
	const { rating } = attributes;
	const filledRating = floor( rating );
	const hasHalf = rating % 1 !== 0;
	let emptyRating = 5 - filledRating;
	emptyRating = hasHalf && emptyRating > 0 ? emptyRating - 1 : emptyRating;
	let stars = [];
	for ( let rIndex = 0; rIndex < filledRating; rIndex++ ) {
		stars = [ ...stars, <Icon icon="star-filled" key={ `rating-filled-${ rIndex }` } /> ];
	}

	if ( hasHalf ) {
		stars = [ ...stars, <Icon icon="star-half" key="rating-half" /> ];
	}

	if ( emptyRating > 0 ) {
		for ( let rIndex = 0; rIndex < emptyRating; rIndex++ ) {
			stars = [ ...stars, <Icon icon="star-empty" key={ `rating-empty-${ rIndex }` } /> ];
		}
	}

	return stars;
};

export { showRatingStar };
